export enum MaintenanceOrderEnums {
  //Estados
  abierta = 1,
  cierreInicial = 2,
  cierreFinal = 3,
  anulada = 4,
}



export enum ClassMaintenanceOrderEnum {
  //Clases de orden de mantenimiento
  enTaller = 1,
  enSitio = 2,
  programada = 3
}

export enum TypeMaintenanceOrderEnum {
  //Tipos de orden de mantenimiento
  equipoPropioDeAlmacen = 1,
  equipoDeTerceroEnTaller = 2,
  equipoPropioEnObra = 3,
  equipoClienteEnObra = 4,
  equipoDeTerceroEnCampo = 5,
  mantenimientoProgramado = 6,
  equipoPropioDeObra = 7,
}

export enum WorkshopTypeEnum {
  taller2 = 2,
  taller3 = 3
}

export enum TypeMaintenanceEnum {
  preventivo = 1,
  correctivo = 2,
  predictivo = 3
}